export enum AvailableBackendType {
  ERP = 'erp'
}
